import { getCookie } from '@tencent/ark-utils/lib/cookie';
export { getCookie };
export var getXsrfToken = function getXsrfToken() {
  var _getCookie;
  return (_getCookie = getCookie('TOK')) !== null && _getCookie !== void 0 ? _getCookie : '';
};
//# sourceMappingURL=cookies.js.map